import f from "../../../funcs";
import $ from "jquery";
import Events from "../../../classes/Events";
import Backbone from "backbone";
import MenuItems from "./model/MenuItems";
import MenuView from "./view/MenuView";


export default Events.extend("Menu", {

    init(params) {
        let that = this;
        that.on("*", function(name) {
            let args = [].slice.call(arguments).slice(1);
            let method = that[ "on_" + name ];

            if ( f.isFunction(method) ) {
                method.apply(that, args);
            }
        });

        params = params || {};
        this.initItems(params.items);
        this.initView(params.view);
    },

    initItems(params) {
        let that = this;

        params = params || [];
        that.items = new MenuItems(params);

        return that;
    },

    initView(params) {
        let that = this;

        params = $.extend({
            //default view params
            model: new Backbone.Model({
                appVersion: window.appVersion
            })
        }, params);
        params.items = that.items;
        params.menu = this;

        let _MenuView = this.MenuView || MenuView;
        that.view = new _MenuView(params);

        that.view.on("go", function(model, e) {
            that.trigger("go " + model.get("action"), model, e);
        });

        this.view.$el.addClass("tab-area");
        this.view.$el.data("tab-area", this);

        return that;
    },

    on_go() {
        // some code...
    }
});
